import React, { useMemo, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import {
  ActionButtonHandle,
  FormPanel,
  RemoteTableField,
  ScrollableSource,
  TableFieldHandle,
  TableFieldToolbarProps,
} from '@eas/common-web';
import { FormTableCount } from '@components/form/table-field/form-table-count';
import { Draft } from '@models';
import { useDraftColumns } from './draft-columns';
import { DraftDialog } from './draft-dialog';
import { DraftToolbar } from './draft-toolbar';

export interface DraftFieldProps {
  disabled: boolean;
  source?: ScrollableSource<Draft>;
}

export function DraftField({ disabled, source }: DraftFieldProps) {
  const columns = useDraftColumns();

  const tableRef = useRef<TableFieldHandle>(null);
  const editRef = useRef<ActionButtonHandle>(null);

  const ToolbarComponent = useMemo(
    () =>
      function Toolbar(props: TableFieldToolbarProps) {
        return <DraftToolbar {...props} ref={editRef} disabled={disabled} />;
      },
    [disabled]
  );

  if (!source) {
    return <> Missing DRAFT_SOURCE </>;
  }

  return (
    <FormPanel
      label={
        <FormattedMessage
          id="ES__DRAFTS__PANEL_TITLE"
          defaultMessage="Koncepty"
        />
      }
      expandable={true}
      defaultExpanded={true}
      summary={<FormTableCount source={source} />}
    >
      <RemoteTableField
        ref={tableRef}
        disabled={disabled}
        columns={columns}
        source={source}
        maxRows={7}
        ToolbarComponent={ToolbarComponent}
        onRowClick={(draft, index) => {
          if (!disabled && !draft?.finalVersion) {
            tableRef.current?.setSelectedIndex(index);
            editRef.current?.executeAction();
          }
        }}
        showDetailBtnCond={() => true}
        FormFieldsComponent={() => (
          <div style={{ width: 700 }}>
            <Typography variant="body1" style={{ marginBottom: 8 }}>
              <FormattedMessage
                id="ES__DRAFTS__DESCRIPTION"
                defaultMessage="Koncept:"
              />
            </Typography>
            <DraftDialog disabled={disabled} />
          </div>
        )}
      />
    </FormPanel>
  );
}
